const HEX_TO_NAME = {
  '#ff6b6b': { he: 'אדום', en: 'Red' },
  '#feca57': { he: 'צהוב', en: 'Yellow' },
  '#48dbfb': { he: 'תכלת', en: 'Light blue' },
  '#ff9ff3': { he: 'ורוד בהיר', en: 'Light pink' },
  '#54a0ff': { he: 'כחול', en: 'Blue' },
  '#5f27cd': { he: 'סגול', en: 'Purple' },
  '#00d2d3': { he: 'טורקיז', en: 'Turquoise' },
  '#ff9f43': { he: 'כתום', en: 'Orange' },
  '#ee5a24': { he: 'כתום כהה', en: 'Dark orange' },
  '#1dd1a1': { he: 'ירוק מנטה', en: 'Mint' },
  '#2ecc71': { he: 'ירוק', en: 'Green' },
  '#e056fd': { he: 'סגול ורוד', en: 'Magenta' },
  '#ffffff': { he: 'לבן', en: 'White' },
  '#95a5a6': { he: 'אפור', en: 'Gray' },
  '#2c3e50': { he: 'כחול כהה', en: 'Navy' },
  '#000000': { he: 'שחור', en: 'Black' },
  '#ffd700': { he: 'זהב', en: 'Gold' },
  '#c0c0c0': { he: 'כסף', en: 'Silver' },
  '#cd7f32': { he: 'ברונזה', en: 'Bronze' },
  '#ff69b4': { he: 'ורוד', en: 'Pink' },
  '#00ffff': { he: 'ציאן', en: 'Cyan' },
  '#ff1493': { he: 'ורוד חזק', en: 'Hot pink' },
  '#7fff00': { he: 'ירוק ליים', en: 'Lime' },
  '#ff4500': { he: 'כתום אדמדם', en: 'Orange red' },
  '#da70d6': { he: 'סחלב', en: 'Orchid' },
  '#e6e6fa': { he: 'לבנדר', en: 'Lavender' },
}

function normHex(hex) {
  const h = String(hex || '').trim().toLowerCase()
  if (!h) return ''
  return h.startsWith('#') ? h : `#${h}`
}

export function getColorName(hex, lang = 'he') {
  const key = normHex(hex)
  const rec = HEX_TO_NAME[key]
  if (rec) return rec[lang] || rec.he
  return lang === 'en' ? 'Custom color' : 'צבע מותאם'
}

